module.exports = __webpack_public_path__ + "d529fde72e155c879bc1dc426be32c82.svg";